// import { AntDesignOutlined } from "@ant-design/icons";
import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getGroups: '/catalog/group',
  opGroup: '/catalog/group',
}

// get Groups
export async function getGroups(token) {
  const auth = `Bearer ${token}`
  // console.log('auth:', auth)
  const url = fsConfig.root + fsConfig.getGroups
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: auth,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`

        // el usuario y el grupo lo hago objeto
        o.company = JSON.parse(o.company)
        o.user = JSON.parse(o.user)
        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo grupos',
        description: error.message,
      })
    })
}

// add new group
export async function postGroup(token, group) {
  const url = fsConfig.root + fsConfig.opGroup
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // elimina los que no son necesarios para enviar a grabar
  delete group.group
  delete group.grouping

  return axios
    .post(url, group, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error agregando grupo',
        description: error.message,
      })
    })
}

export async function putGroup(token, group) {
  const url = fsConfig.root + fsConfig.opGroup
  const newConfig = {
    headers: {
      'Content-Type': 'application/json',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }

  // elimina los datos que no se requieren
  const { key } = group
  delete group.key
  delete group.user
  delete group.company
  delete group.group
  delete group.grouping

  return axios
    .put(url, group, newConfig)
    .then(response => {
      /*           const result = response.data.map((el, ndx) => {
              const o = Object.assign({}, el )
              o.key = `${ndx + 1}`
              return o
          })
          response.data = result */
      response.key = key
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error grabando grupo',
        description: error.message,
      })
    })
}

export async function deleteGroup(token, groupUid) {
  const url = `${fsConfig.root}${fsConfig.opGroup}/${groupUid}`
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .delete(url, newConfig)
    .then(response => {
      const { result } = response.data
      return result
    })
    .catch(error => {
      notification.warning({
        message: 'Error eliminando group',
        description: error.message,
      })
    })
}
